import { type QueryKeyRoot } from '../queryKeyRoots';

export const DOWNLOAD_QUERY_KEYS = {
  agreements: (assetId?: string) =>
    ['downloadAgreements', assetId] as const satisfies readonly [
      QueryKeyRoot,
      ...unknown[]
    ],
  imageSizes: (genRequestId: string, index: number) =>
    ['DOWNLOAD_IMAGE_SIZES', genRequestId, index] as const satisfies readonly [
      QueryKeyRoot,
      ...unknown[]
    ],
  batchDownloadData: () =>
    ['batchDownloadData'] as const satisfies readonly [
      QueryKeyRoot,
      ...unknown[]
    ],
} as const;
